var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinkBoatHat = function SvgPinkBoatHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 43,
    viewBox: "0 0 65 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3282 28.6977L0 20.3802L21.9491 19.6871L17.3282 28.6977Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3282 28.6977L0 20.3802L21.9491 19.6871L17.3282 28.6977Z",
    fill: "url(#boat_hat_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6741 28.4668L42.2808 19.4561L64.6919 18.532L49.6741 28.4668Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6741 28.4668L42.2808 19.4561L64.6919 18.532L49.6741 28.4668Z",
    fill: "url(#boat_hat_paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3146 36.2315L32.4042 0.880371L52.4382 29.4929L36.2655 38.5946L32.3146 36.2315Z",
    fill: "url(#boat_hat_paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4163 0.572083L9.08734 27.6623L32.4163 35.6353V0.572083Z",
    fill: "url(#boat_hat_paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1151 0.796906L8.78619 27.8872L32.1151 35.8601V0.796906Z",
    fill: "url(#boat_hat_paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62973 39.4833L0.308044 20.7496L30.571 25.084L65 18.9013L58.1494 37.7749L31.7913 43.1441L7.62973 39.4833Z",
    fill: "url(#boat_hat_paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62973 39.4833L0.308044 20.7496L30.571 25.084L65 18.9013L58.1494 37.7749L31.7913 43.1441L7.62973 39.4833Z",
    fill: "url(#boat_hat_paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32169 39.175L0 20.4413L30.263 24.7756L64.692 18.593L57.8413 37.4666L31.4833 42.8358L7.32169 39.175Z",
    fill: "url(#boat_hat_paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32169 39.175L0 20.4413L30.263 24.7756L64.692 18.593L57.8413 37.4666L31.4833 42.8358L7.32169 39.175Z",
    fill: "url(#boat_hat_paint8_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint0_linear",
    x1: 10.9745,
    y1: 19.6871,
    x2: 10.9745,
    y2: 28.6977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint1_linear",
    x1: 53.4863,
    y1: 18.532,
    x2: 53.4863,
    y2: 28.4668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint2_linear",
    x1: 44.1175,
    y1: -7.28479,
    x2: 38.2955,
    y2: 69.7852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint3_linear",
    x1: 27.4932,
    y1: -9.59351,
    x2: 27.9553,
    y2: 64.4151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint4_linear",
    x1: 32.1911,
    y1: 21.2884,
    x2: 2.07938,
    y2: -9.82444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint5_linear",
    x1: 32.6531,
    y1: 4.63812,
    x2: 32.6531,
    y2: 36.8291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint6_linear",
    x1: 32.6531,
    y1: 10.6451,
    x2: 32.6531,
    y2: 54.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint7_linear",
    x1: 31.883,
    y1: 30.4528,
    x2: 32.3451,
    y2: 60.0095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint8_linear",
    x1: -39.6612,
    y1: 28.2195,
    x2: 91.5673,
    y2: 28.0654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743124,
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinkBoatHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pink_boat_hat.e113d715.svg";
export { ForwardRef as ReactComponent };